import React from 'react';
import { Flexbox, Text } from '@sonika-se/ui-kit/components';
import { useEnvironment } from '@sonika-se/ui-kit/hooks';
import { graphql, useFragment } from 'react-relay/hooks';
import Avatar from '../Avatar';
import UserNameLabel from '~/components/UserNameLabel';
export const UserSnippet = (props) => {
    const { avatarSize = 'small', avatarVisible = true, className, linkDisabled = false, nameVisible = true, style, userRef, } = props;
    const user = useFragment(graphql `
      fragment UserSnippet_user on User {
        ...Avatar_iHaveAvatar
        ...UserNameLabel_user
        id
      }
    `, userRef);
    const { frontUrls } = useEnvironment();
    return (<Flexbox align="center" className={className} gap="small" style={style}>
      {avatarVisible && <Avatar iHaveAvatarRef={user} size={avatarSize}/>}
      {nameVisible && (<>
          {linkDisabled ? (<Text bold lineHeight="normal">
              <UserNameLabel user={user}/>
            </Text>) : (<a href={`${frontUrls['CORE']}users/${user.id}`}>
              <Text bold lineHeight="normal">
                <UserNameLabel user={user}/>
              </Text>
            </a>)}
        </>)}
    </Flexbox>);
};
export default UserSnippet;
